module.exports = __webpack_public_path__ + "static/parallax-bg-66c3c910be0a322cd02f03b38d2d3bab.jpg";